<template>
  <v-menu bottom left offset-y
    v-model="config.status.active"
    :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn small depressed fab
        v-on="on"
        :class="$props.className || ''">
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </template>
    <v-list :subheader="$vuetify.breakpoint.xsOnly">
      <v-subheader v-if="$vuetify.breakpoint.xsOnly">
        <span class="font-weight-bold">担当：</span>{{ printAuthorName }}
      </v-subheader>
      <v-divider v-if="$vuetify.breakpoint.xsOnly"></v-divider>
      <AuthorToolkit @close="close"></AuthorToolkit>
      <ArrangesToolkit v-if="$vuetify.breakpoint.xsOnly"
        :items="getArrangeItems"
        @opened="close"
      />
      <OnlineToolkit @close="close"></OnlineToolkit>
      <DevToolkit v-if="isDeveloper" />
    </v-list>
  </v-menu>
</template>

<script>
import AuthorToolkit from './author'
import ArrangesToolkit from './arranges'
import OnlineToolkit from './online'
import DevToolkit from '@/components/dev'
export default {
  name: 'client-toolkits',
  components: {
    AuthorToolkit,
    ArrangesToolkit,
    OnlineToolkit,
    DevToolkit
  },
  props: [ 'className', 'arranges' ],
  data () {
    return {
      config: {
        status: {
          active: false
        }
      }
    }
  },
  methods: {
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isDeveloper () {
      let roles = this.$store.getters['author/get']('roles')
      return roles.includes('developer')
    },
    getArrangeItems () {
      return this.$props.arranges || []
    },
    printAuthorName () {
      let userid = this.$store.getters['client/get']('author')
      let authors = this.$store.getters['config/get']('authors')
      return authors[userid] ? authors[userid].name[0] : userid
    }
  }
}
</script>
